<template>
  <v-dialog v-model="isDialogOpened" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card v-if="!loading">
      <v-card-title class="primary white--text">
        <v-toolbar-title>CHỈNH SỬA CÔNG VIỆC</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-form ref="update-task-form">
          <div class="task-title mb-4">
            <v-text-field
              v-model="title"
              label="Tên đầu mục công việc"
              class="required"
              outlined
              dense
              :rules="[$rules.required]"
              hide-details="auto"
            ></v-text-field>
          </div>
          <div class="task-content mb-4">
            <v-textarea
              v-model="content"
              label="Nội dung công việc"
              hide-details="auto"
              rows="3"
              full-width
              auto-grow
              clearable
              outlined
              dense
            ></v-textarea>
          </div>
          <div class="task-data mb-4">
            <div class="data-title">Người giao</div>
            <div class="task-creator">{{ creatorName }}</div>
          </div>
          <div class="task-data mb-4">
            <div class="data-title">Người nhận</div>
            <div class="task-receiver">{{ receiverName }}</div>
          </div>
          <v-row class="mb-4">
            <v-col cols="12" md="6">
              <DatePicker
                :date.sync="startTime"
                @update:date="handleStartTimeChange"
                :maxDate="endTime"
                label="Bắt đầu từ"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="6">
              <DatePicker
                :date.sync="endTime"
                @update:date="handleEndTimeChange"
                :minDate="startTime"
                label="Kết thúc trước"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <div v-if="category === 'done'" class="task-data">
            <div class="data-title">Đánh giá</div>
            <div class="evaluation">
              <v-select
                v-model="selectedEvaluation"
                :items="taskEvaluations"
                label="Chọn đánh giá"
                hide-details="auto"
                outlined
                dense
              ></v-select>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn class="ma-2" outlined @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="updateTaskHandler">Lưu</v-btn>
      </v-card-actions>
    </v-card>
    <v-skeleton-loader v-else class="mx-auto" type="article, actions"></v-skeleton-loader>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import get from 'lodash-es/get'
import DatePicker from './DatePicker.vue'

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      id: '',
      isDialogOpened: false,
      title: '',
      content: '',
      category: '',
      creator: null,
      receiver: null,
      selectedEvaluation: 0,
      showReceiverError: false,
      startTime: '',
      endTime: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters('task', ['contributorsByID']),
    ...mapState('constant', ['taskEvaluations']),
    creatorName() {
      const creatorID = get(this.creator, 'id', null)
      if (creatorID && this.contributorsByID[creatorID]) {
        return this.contributorsByID[creatorID].name
      }
      return ''
    },
    receiverName() {
      const receiverID = get(this.receiver, 'id', null)
      if (receiverID && this.contributorsByID[receiverID]) {
        return this.contributorsByID[receiverID].name
      }
      return ''
    }
  },
  methods: {
    ...mapActions('task', ['fetchTaskByID', 'updateTask']),
    ...mapActions('teachers', ['fetchTeachers']),
    ...mapActions('staff', ['fetchStaffs']),
    cancel() {
      this.isDialogOpened = false
    },
    async openDialog(taskID) {
      this.isDialogOpened = true
      this.id = taskID
      this.loading = true
      const taskData = await this.fetchTaskByID(taskID)
      this.title = taskData.title
      this.content = taskData.content
      this.category = taskData.category
      this.creator = taskData.creator
      this.receiver = taskData.receiver
      this.selectedEvaluation = taskData.evaluate
      this.startTime = taskData.startTime ? taskData.startTime : ''
      this.endTime = taskData.endTime ? taskData.endTime : ''
      this.loading = false
    },
    async updateTaskHandler() {
      if (!this.$refs['update-task-form'].validate()) {
        return
      }
      this.$loading.active = true
      const updateTaskData = {
        id: this.id,
        title: this.title,
        content: this.content,
        evaluate: this.selectedEvaluation,
        startTime: this.startTime ? this.startTime : null,
        endTime: this.endTime ? this.endTime : null
      }
      await this.updateTask(updateTaskData)
      this.$loading.active = false
      this.isDialogOpened = false
    },
    handleStartTimeChange(time) {
      this.startTime = time
    },
    handleEndTimeChange(time) {
      this.endTime = time
    }
  }
}
</script>

<style lang="scss" scoped>
.task-title {
  width: 100%;
}
.task-data {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .data-title {
    flex: 0 0 150px;
    padding: 4px 0;
  }
}
.evaluation {
  width: 170px;
}
</style>
